<template>
  <div class="modal PhoneVerificationModal">
    <div class="modal--backdrop" @click="dismiss()"></div>
    <div class="modal--content">
      <div class="modal--content-body">
        <figure class="twoFaImg">
          <img src="@/assets/images/Success.svg" alt="" />
        </figure>
        <div class="HeadingtextinfoDv">
          <h2>{{ $t("setting.twoFactorAuth.success.title") }}</h2>
          <p>
            {{
              $t("setting.twoFactorAuth.success.description", {
                phone: userData,
              })
            }}
          </p>
        </div>

        <div class="btninfoDv">
          <button class="btn btn--primary" @click="dismiss()">
            {{ $t("setting.twoFactorAuth.success.doneButton") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { getAuth, RecaptchaVerifier, User } from "firebase/auth";
import { popModal, promptModal } from "jenesius-vue-modal";
import { defineComponent, onMounted, ref, computed } from "vue";
export default defineComponent({
  name: "Testing",
  props: {
    userData: Object,
  },
  setup(props) {
    const dismiss = () => popModal();
    return {
      dismiss,
    };
  },
});
</script>
<style lang="scss" scoped>
.PhoneVerificationModal {
  .modal--content {
    max-height: 450px;
    .modal--content-body {
      padding: 30px 60px;
      .twoFaImg {
        display: flex;
        justify-content: center;
        padding-top: 20px;
        padding-bottom: 30px;
        img {
          width: 140px;
        }
      }
      .HeadingtextinfoDv {
        margin-bottom: 34px;
        h2 {
          font-size: var(--font-2xl);
          color: var(--text-color);
          text-align: center;
          margin: 0px;
          padding: 0px;
          line-height: 1;
          letter-spacing: 0px;
          font-weight: 500;
        }
        p {
          font-size: var(--font-2sm);
          color: var(--text-color);
          text-align: center;
          margin: 15px 0px 0px;
          padding: 0px;
          line-height: 1.6;
          letter-spacing: 0px;
          font-weight: 400;
          opacity: 0.7;
        }
      }
      .inputWithLabelDv {
        margin: 20px 0px;

        .verifyInfoChangeDv {
          background: var(--base-light);
          color: var(--text-color);
          height: 35px;
          width: max-content;
          padding: 0px 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          border-radius: 4px;
          max-width: 65px;
          min-width: 55px;

          p {
            line-height: 1;
            font-size: var(--font-xs);
            margin: 0px;
            padding: 0px;
            letter-spacing: 0px;
            font-weight: 400;
          }
        }
      }
      .resendDv {
        p {
          font-size: var(--font-sm);
          color: var(--text-color);
          opacity: 0.3;
          cursor: pointer;
          text-align: center;
          margin: 0px 0px 20px;
          padding: 0px;
          letter-spacing: 0px;
          line-height: 1;
        }
      }
      .btninfoDv {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 20px;
        flex-direction: column;
        .btn {
          font-size: var(--font-2sm);
          width: 100%;
          margin: 0px;
        }
      }
      .code-resend {
        margin: 0px 0px 20px;
        p {
          margin: 0;
          text-align: center;
          font-size: var(--font-xs);
          font-weight: 400;
          span {
            color: var(--secondary-color);
          }
        }
        a {
          text-align: center;
          margin: 0 auto;
          display: block;
          margin-top: 20px;
          color: var(--text-color);
          cursor: pointer;
          font-size: var(--font-xs);
          font-weight: 500;
          &.disabled {
            opacity: 0.5;
            pointer-events: none;
            cursor: default;
          }
        }
      }
    }
  }
}
</style>
